module.exports = __webpack_public_path__ + "static/img/supplier.70e04fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/supplier.png
// module id = xsMT
// module chunks = 1